// Site Configuration - Easy to update placeholders
// Update these values as needed

export const siteConfig = {
  // Company Info
  companyName: "Claritech Pool Systems",
  
  // Contact
  email: "claritechpoolsystems@gmail.com",
  
  // Social Links - UPDATE THESE
  linkedInUrl: "#linkedin", // Replace with actual LinkedIn company page URL
  
  // Formspree - UPDATE THIS
  // Get your endpoint at https://formspree.io
  formspreeEndpoint: "https://formspree.io/f/YOUR_FORM_ID", // Replace YOUR_FORM_ID with your actual Formspree form ID
  
  // SEO
  seo: {
    title: "Claritech Pool Systems | Pool Supply & Technical Support",
    description: "We operate across Italy, Canada and the United States through an international supply network. Pool treatment supplies & operational support for hospitality and commercial pools.",
    ogImage: "https://images.unsplash.com/photo-1558239041-c5fc98b811a7?w=1200&h=630&fit=crop",
  },
  
  // Markets
  markets: ["Italy", "Canada", "USA"],
  
  // Images - High quality pool/hospitality images
  images: {
    logo: "https://customer-assets.emergentagent.com/job_claritech-supply/artifacts/v87323lu_Progetto%20senza%20titolo.png",
    hero: "https://images.unsplash.com/photo-1558239041-c5fc98b811a7?auto=format&fit=crop&w=1920&q=80",
    // New images from user upload
    about: "https://customer-assets.emergentagent.com/job_claritech-supply/artifacts/di5ihf4j_31154.jpg",
    trust: "https://customer-assets.emergentagent.com/job_claritech-supply/artifacts/aif7cpsl_2151945662.jpg",
  }
};

export default siteConfig;
